var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCameraDisable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1651386147632,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 1561,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 200,
    height: 200,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "@font-face { font-family: feedback-iconfont; src: url(\"//at.alicdn.com/t/font_1031158_u69w8yhxdu.woff2?t=1630033759944\") format(\"woff2\"), url(\"//at.alicdn.com/t/font_1031158_u69w8yhxdu.woff?t=1630033759944\") format(\"woff\"), url(\"//at.alicdn.com/t/font_1031158_u69w8yhxdu.ttf?t=1630033759944\") format(\"truetype\"); }\n"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M896 835.626667L188.373333 128 128 188.373333 195.626667 256H128v597.333333h664.96l42.666667 42.666667zM549.333333 609.706667a85.333333 85.333333 0 0 1-113.706666-113.706667zM213.333333 768V341.333333h67.626667l92.586667 92.586667a170.666667 170.666667 0 0 0 237.866666 237.866667L707.626667 768z m223.573334-512l-69.12-69.12L384 170.666667h256l85.333333 85.333333h170.666667v459.093333l-85.333333-85.333333V341.333333h-120.746667l-24.96-24.96L604.586667 256z m242.133333 241.92l-131.626667-131.626667a170.666667 170.666667 0 0 1 131.626667 131.626667z",
    "p-id": 1562
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraDisable);
export default __webpack_public_path__ + "static/media/camera-disable.4e11fcede488d8e8a8a569865f6f0bf5.svg";
export { ForwardRef as ReactComponent };